export const defaultBasePath = `/:ver/:system_model`;

const baseDatasetPath = `${defaultBasePath}/dataset/:spold_id`;

export const datasetPaths = [
  `${baseDatasetPath}/documentation`,
  `${baseDatasetPath}/exchanges`,
  `${baseDatasetPath}/flows`,
  `${baseDatasetPath}/lci`,
  `${baseDatasetPath}/impact_assessment`,
  `${baseDatasetPath}/direct_contribution`,
  `${baseDatasetPath}/consuming_activities`,
  `${baseDatasetPath}/history`,
  `${baseDatasetPath}/export`,
  `${baseDatasetPath}/supply-chain`,
  `${baseDatasetPath}`, // fallback
];

export const searchPath = `${defaultBasePath}/search`;

export const comparePath = `${defaultBasePath}/compare`;

export const comparePaths = [
  `${comparePath}/impact-assessment`,
  `${comparePath}/exchanges`,
  `${comparePath}/flows`, // legacy slug for the Exchanges tab — Comparison redirects it
  comparePath, // fallback — redirects to the default tab
];
